const auth = 'Basic YXBpQGx1Z2xpbzcuY29tOm1hdGhlbWF0aGVtYXRoZQ==';

export default {
  fetch(path, bodyParams = {}, fetchParams = {}) {
    const headers = new Headers();
    const body = new FormData();
    headers.append('Authorization', auth);
    Object.keys(bodyParams).forEach((key) => {
      body.append(key, bodyParams[key]);
    });

    return fetch(
      path,
      Object.assign(
        {
          headers,
          body,
          method: 'POST'
        },
        fetchParams
      )
    ).then((res) => res.json());
  }
};
